"use client";

import { c as _c } from "react/compiler-runtime";
import { InputHTMLAttributes, useId } from "react";
import clsx from "clsx";
interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
}
export default function Checkbox(t0) {
  const $ = _c(15);
  let label;
  let props;
  if ($[0] !== t0) {
    const {
      label: t1,
      className,
      ...t2
    } = t0;
    label = t1;
    props = t2;
    $[0] = t0;
    $[1] = label;
    $[2] = props;
  } else {
    label = $[1];
    props = $[2];
  }
  const autoId = useId();
  const id = props.id || autoId;
  let t1;
  if ($[3] !== id || $[4] !== props) {
    t1 = <input id={id} type="checkbox" className="peer absolute inset-0 w-full h-full opacity-0 cursor-pointer checkbox" {...props} />;
    $[3] = id;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("w-full h-full rounded border border-gray-400 flex items-center justify-center transition-all duration-200 peer-checked:bg-primary peer-checked:border-primary dark:border-gray-600 dark:peer-checked:bg-primary/90");
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className={t2}><svg viewBox="0 0 12 10" className="w-3 h-3 text-white opacity-0 transition-opacity duration-200" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="1.5 6 4.5 9 10.5 1" /></svg></span>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1) {
    t4 = <div className="relative w-4 h-4">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== label) {
    t5 = <span className="text-sm text-gray-800 dark:text-gray-200">{label}</span>;
    $[10] = label;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <label className="flex items-center gap-2 cursor-pointer select-none">{t4}{t5}</label>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}